import { css } from '@/styled-system/css';

export const calendarStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  width: 'fit-content',
  backgroundColor: { base: 'Calendar.Root.bg.default' },
  rowGap: 'tightest',
});
